import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_regler_trainer",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "coming-soon col-md-12 text-center position-relative" }, [
  /*#__PURE__*/_createElementVNode("h1", null, " UX/UI sera disponible bientôt ")
], -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "title-h4" }
const _hoisted_13 = { class: "col-md-12 mt-3" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = {
  key: 0,
  class: "col-md-6 mb-2 mt-2"
}
const _hoisted_16 = { class: "timeline-content" }
const _hoisted_17 = { class: "d-inline-block w-160" }
const _hoisted_18 = {
  key: 1,
  class: "col-md-6 mb-2 mt-2"
}
const _hoisted_19 = { class: "timeline-content" }
const _hoisted_20 = { class: "d-inline-block w-160" }
const _hoisted_21 = {
  key: 2,
  class: "col-md-6 mb-2 mt-2"
}
const _hoisted_22 = { class: "timeline-content" }
const _hoisted_23 = { class: "d-inline-block w-160" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-12 mt-4" }
const _hoisted_26 = { class: "title-h4" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "col-md-12 mt-3" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = { class: "form-group mr-b-0em" }
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { class: "form-group mr-b-0em" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group mr-b-0em" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_39 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_40 = { class: "form-group mr-b-0em" }
const _hoisted_41 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_42 = { class: "form-group mr-b-0em" }
const _hoisted_43 = {
  key: 3,
  class: "col-md-6"
}
const _hoisted_44 = { class: "form-group mr-b-0em" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "form-group mr-b-0em" }
const _hoisted_47 = { class: "col-md-12" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-12 text-right" }
const _hoisted_50 = {
  type: "submit",
  class: "btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_checkboxInput = _resolveComponent("checkboxInput")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_price_input = _resolveComponent("price-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestTrainerPayment)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            (_ctx.isAdvance)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.i18n.t('views.clients.trainer.payment.advance')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.i18n.t('views.clients.trainer.payment.title')), 1))
          ]),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_regler_trainer', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.requestPaymentTrainer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("form", {
                class: "forms-sample",
                onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.i18n.t('views.clients.trainer.payment.info')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.trainer?.name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("p", _hoisted_16, [
                              _createElementVNode("b", _hoisted_17, _toDisplayString(_ctx.i18n.t('tables.members.name')), 1),
                              _createTextVNode(": " + _toDisplayString(_ctx.trainer?.name), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.trainer?.contractNumber)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("p", _hoisted_19, [
                              _createElementVNode("b", _hoisted_20, _toDisplayString(_ctx.i18n.t('tables.members.contractNumber')), 1),
                              _createTextVNode(": " + _toDisplayString(_ctx.trainer?.contractNumber), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.trainer?.cin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("p", _hoisted_22, [
                              _createElementVNode("b", _hoisted_23, _toDisplayString(_ctx.i18n.t('tables.members.cin')), 1),
                              _createTextVNode(": " + _toDisplayString(_ctx.trainer?.cin), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("h4", _hoisted_26, [
                      (_ctx.isAdvance)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.i18n.t('views.clients.trainer.payment.advance')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.i18n.t('views.clients.trainer.payment.title')), 1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestPaymentTrainer.targetMonth,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestPaymentTrainer.targetMonth) = $event)),
                            label: _ctx.i18n.t('tables.trainer.targetMonth'),
                            disabled: true
                          }, null, 8, ["modelValue", "label"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_checkboxInput, {
                            text: _ctx.i18n.t('tables.trainer.add_advance'),
                            modelValue: _ctx.requestPaymentTrainer.isAdvance,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestPaymentTrainer.isAdvance) = $event)),
                            v: _ctx.v$.isAdvance,
                            name: "isAdvance",
                            id: "isAdvance"
                          }, null, 8, ["text", "modelValue", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_date_field, {
                            modelValue: _ctx.requestPaymentTrainer.paymentDate,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestPaymentTrainer.paymentDate) = $event)),
                            label: _ctx.i18n.t('tables.payment.paymentDate'),
                            v: _ctx.v$.paymentDate,
                            disabled: false,
                            fixedDays: 1,
                            isFixedDays: true
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_SingleSelect, {
                          TextLabel: _ctx.i18n.t('tables.payment.paymentMethod'),
                          trackby: `id`,
                          label: `name`,
                          valueProp: `id`,
                          modelValue: _ctx.requestPaymentTrainer.paymentMethod,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestPaymentTrainer.paymentMethod) = $event)),
                          placeholder: _ctx.i18n.t('tables.payment.paymentMethod'),
                          arrayOptions: _ctx.payment_methodsList,
                          refs: "paymentMethod",
                          v: _ctx.v$.paymentMethod
                        }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                      ]),
                      (_ctx.requestPaymentTrainer.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createVNode(_component_SingleSelect, {
                              TextLabel: _ctx.i18n.t('tables.payment.bankName'),
                              trackby: `id`,
                              label: `name`,
                              valueProp: `id`,
                              modelValue: _ctx.requestPaymentTrainer.bankName,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestPaymentTrainer.bankName) = $event)),
                              placeholder: _ctx.i18n.t('tables.payment.bankName'),
                              arrayOptions: _ctx.bank_namesList,
                              refs: "bankName",
                              v: _ctx.v$.bankName
                            }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestPaymentTrainer.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_inputText, {
                                modelValue: _ctx.requestPaymentTrainer.chequeName,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestPaymentTrainer.chequeName) = $event)),
                                label: _ctx.i18n.t('tables.payment.chequeName'),
                                v: _ctx.v$.chequeName,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestPaymentTrainer.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_inputText, {
                                modelValue: _ctx.requestPaymentTrainer.chequeNum,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestPaymentTrainer.chequeNum) = $event)),
                                label: _ctx.i18n.t('tables.payment.chequeNum'),
                                v: _ctx.v$.chequeNum,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestPaymentTrainer.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_date_field, {
                                modelValue: _ctx.requestPaymentTrainer.dueDate,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestPaymentTrainer.dueDate) = $event)),
                                label: _ctx.i18n.t('tables.payment.dueDate'),
                                v: _ctx.v$.dueDate,
                                disabled: false,
                                fixedDays: 1,
                                isFixedDays: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_price_input, {
                            modelValue: _ctx.requestPaymentTrainer.amount_paid,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestPaymentTrainer.amount_paid) = $event)),
                            label: _ctx.i18n.t('tables.payment.amount_paid'),
                            v: _ctx.v$.amount_paid,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('tables.trainer.targetMonth')), 1),
                          _createTextVNode(": " + _toDisplayString(_ctx.requestPaymentTrainer.targetMonth), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('tables.payment.paymentDate')), 1),
                          _createTextVNode(": " + _toDisplayString(_ctx.formatDate(_ctx.requestPaymentTrainer.paymentDate)), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('tables.trainer.salary')), 1),
                          _createTextVNode(": " + _toDisplayString(_ctx.trainer?.salary ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('tables.trainer.total_advance')), 1),
                          _createTextVNode(": " + _toDisplayString(_ctx.trainer?.total_advance ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('tables.trainer.total_paid')), 1),
                          _createTextVNode(": " + _toDisplayString(_ctx.trainer?.total_paid ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('tables.trainer.remaining_salary')), 1),
                          _createTextVNode(": " + _toDisplayString(_ctx.trainer?.remaining ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("button", _hoisted_50, _toDisplayString(_ctx.action == 'add' ? _ctx.i18n.t('button.add') : _ctx.i18n.t('button.edit')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.emptyState())),
                      class: "btn btn-cancel"
                    }, _toDisplayString(_ctx.i18n.t('button.cancel')), 1)
                  ])
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}